import React from 'react'

import {
  BorderStyle,
  Box,
  Color,
  Display,
  FontWeight,
  Link,
  LinkVariant,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import { buildMenuExperienceCategoryHref } from './MenuExperienceCategoryNav'
import type { MenuExperienceNavItem } from './hooks/useMenuExperienceNavigation'

type MenuExperienceProspectCategoryNavProps = {
  tabs: MenuExperienceNavItem[]
  pathname?: string
  query: Record<string, unknown>
}

const TabLink = withCitrusTheme(Link, (theme) => ({
  borderBottom: `1px solid ${theme.color(Color.ColdGrey_100)}`,
  boxSizing: 'border-box',
  display: Display.Flex,
  flex: '1 0 0',
  height: theme.spacing(12),
  justifyContent: 'center',
  padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  '&:focus-visible': {
    outline: `2px solid ${theme.color(Color.Secondary_400)}`,
    outlineOffset: '-2px',
  },
  '&[aria-current="page"]': {
    borderBottom: `2px solid ${theme.color(Color.Secondary_400)}`,
  },
}))

const TabRow = withCitrusTheme(Box, () => ({
  margin: '0 auto',
  marginBottom: '-1px',
}))

export const MenuExperienceProspectCategoryNav = ({
  tabs,
  pathname = '/menu',
  query,
}: MenuExperienceProspectCategoryNavProps) => (
  <Box
    data-testid="prospect-tabs"
    bg={Color.White}
    borderStyle={BorderStyle.Solid}
    borderColor={Color.ColdGrey_100}
    borderBottomWidth={0.5}
  >
    <nav aria-label="Menu categories">
      <TabRow maxWidth="1600px">
        <Box display={Display.Flex} maxWidth="376px">
          {tabs.map((tab) => (
            <TabLink
              key={tab.id}
              href={buildMenuExperienceCategoryHref({ pathname, query, slug: tab.slug })}
              variant={LinkVariant.None}
              data-slug={tab.slug}
              aria-current={tab.selected ? 'page' : undefined}
              onClick={tab.onClick}
            >
              <Text color={Color.ColdGrey_800} fontWeight={FontWeight.Bold} size={4}>
                {tab.text}
              </Text>
            </TabLink>
          ))}
        </Box>
      </TabRow>
    </nav>
  </Box>
)
